<script>
import { toDecPercent } from '@utils/Format'
import GeneralValueDiff from '@modules/global/components/general-value-diff'
import FeedbackWrapper from '@modules/global/components/feedback-wrapper/feedback-wrapper.vue'
import { WALLET_EMPTY_MESSAGE } from '@modules/consolidator/constants/Text'
import { getBenchmarkStats } from '@modules/consolidator/utils/get-benchmark-stats/get-benchmark-stats'

export default {
  name: 'MercadoIndicadores',
  components: {
    GeneralValueDiff,
    FeedbackWrapper,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    benchmarksStatistics: {
      type: Object,
      default: () => ({}),
    },
    brokerData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      toDecPercent,
      cardMinHeight: 570,
      WALLET_EMPTY_MESSAGE,
    }
  },
  computed: {
    referencePeriod() {
      if (!this.brokerData) {
        return ''
      }

      const { data_inicio, data_fim } = this.brokerData

      if (data_inicio && data_fim) {
        return `De ${data_inicio} até ${data_fim}`
      }

      return ''
    },
    benchmarks() {
      return this.$store.getters['settings/benchmarks']
    },
    sortedIndicators() {
      if (!this.formattedIndicators || this.formattedIndicators.length === 0) {
        return []
      }

      const ordemPrioritaria = ['CDI', 'IPC-A', 'IBOVESPA']
      const currentItems = this.formattedIndicators.map(
        (item) => item.indicador
      )

      const hasPriorityOrder = ordemPrioritaria.every(
        (item, index) => currentItems[index] === item
      )

      return hasPriorityOrder
        ? this.formattedIndicators
        : this.sortIndicadores([...this.formattedIndicators])
    },
    formattedIndicators() {
      if (!this.benchmarksStatistics) return []

      const indicadores = this.benchmarks.map((bench) => {
        const stats = getBenchmarkStats(this.benchmarksStatistics, bench) || {}

        const hasRentabilidade =
          stats.rent_inicio !== null && stats.rent_inicio !== undefined
        const hasVolume = stats.vol !== null && stats.vol !== undefined

        return {
          indicador: bench.nome,
          rentabilidade: hasRentabilidade ? stats.rent_inicio : '-',
          volatilidade: hasVolume ? this.toDecPercent(stats.vol) : '-',
        }
      })

      return indicadores
    },
    tableHeaders() {
      return [
        { text: 'Indicadores', value: 'indicador', sortable: false },
        { text: 'Rentabilidade', value: 'rentabilidade', sortable: false },
        { text: 'Volatilidade', value: 'volatilidade', sortable: false },
      ]
    },
    contentHeight() {
      return 450
    },
  },
  methods: {
    sortIndicadores(indicadores) {
      const ordemPrioritaria = ['CDI', 'IPC-A', 'IBOVESPA']

      return indicadores.sort((a, b) => {
        const indexA = ordemPrioritaria.indexOf(a.indicador)
        const indexB = ordemPrioritaria.indexOf(b.indicador)

        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB
        }

        if (indexA !== -1 && indexB === -1) {
          return -1
        }

        if (indexA === -1 && indexB !== -1) {
          return 1
        }

        return a.indicador.localeCompare(b.indicador)
      })
    },
  },
}
</script>

<template>
  <FeedbackWrapper
    :loading="loading"
    :message="WALLET_EMPTY_MESSAGE"
    :minHeight="loading ? '100%' : cardMinHeight"
    bordered
    class="mercado-indicadores"
  >
    <div class="mercado-indicadores__card az-card-bordered">
      <div class="mercado-indicadores__header">
        <div class="az-ds-card-title"> Mercado </div>
        <span class="az-text-small"> {{ referencePeriod }} </span>
      </div>

      <v-data-table
        class="mercado-indicadores__table table-new-ux-v1"
        :headers="tableHeaders"
        :items="sortedIndicators"
        :height="contentHeight"
        fixed-header
        disable-pagination
        hide-default-footer
      >
        <template v-slot:item.rentabilidade="{ item }">
          <GeneralValueDiff
            v-if="typeof item.rentabilidade === 'number'"
            :value="item.rentabilidade"
            :value-formatted="toDecPercent(item.rentabilidade)"
            style="margin: 0 !important; font-size: 12px"
          />
          <span v-else> - </span>
        </template>
      </v-data-table>
    </div>
  </FeedbackWrapper>
</template>

<style lang="sass">
.mercado-indicadores
  &__card
    padding-bottom: 32px

  &__header
    display: flex
    margin-bottom: 33px
    align-items: flex-start
    justify-content: space-between
</style>
